import { FC } from 'react'
import { Button } from '@components/Button'
import { RouteError } from '@src/errors/RouteError'
import { ErrorComponentProps, SearchParamError } from '@tanstack/react-router'

import {
  FlowCard,
  FlowCardCopy,
  FlowCardFooter,
  FlowCardHeader,
  FlowCardMain,
} from '../FlowCard'
import { RedFlag } from '../Icons/RedFlag'

export const GenericErrorCard: FC<ErrorComponentProps> = ({ error }) => {
  const isSearchParamError = error instanceof SearchParamError
  const isRouteError = error instanceof RouteError

  let message = 'An error occurred. Please try again later.'
  let title = 'Oops! Something went wrong.'

  if (isSearchParamError) {
    message = 'Invalid search parameters.'
  } else if (isRouteError) {
    message = error.message
    if (error.title) {
      title = error.title
    }
  }
  return (
    <FlowCard>
      <FlowCardMain showBack={false}>
        <RedFlag className="mx-auto mb-4" />
        <FlowCardHeader>{title}</FlowCardHeader>
        <FlowCardCopy>{message}</FlowCardCopy>
      </FlowCardMain>
      <FlowCardFooter>
        <Button as="a" href="https://support.branchapp.com/">
          Contact Support
        </Button>
      </FlowCardFooter>
    </FlowCard>
  )
}
